<!-- 酒店直采特价 -->
<template>
    <div class='container'>
        <div class="header">
            <div class="headerBox" v-for="item in heatTest" :key="item.code">
                {{ item.text }}
            </div>
        </div>
        <div class="main">
            <div class="mianLine">
                <p class="title">您感兴趣的资源：</p>
                <p class="p_1">法国巴黎 Mercure Hotel ****</p>
            </div>
            <div class="mainDetail" v-for="item in 2" :key="item">
                <div class="mianLine">
                    <p class="title">入住及离店日期：</p>
                    <el-date-picker size="small" style="width: 2.5rem;margin-right: 0.05rem;" v-model="value1"
                        type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                    <p class="p_2">2晚</p>
                    <el-button size="small" class="addBtn">添加其他入住日期</el-button>
                </div>
                <div class="mianLine">
                    <p class="title">入住人数：</p>
                    <el-input-number size="small" v-model="value1" :min="0" :max="999"></el-input-number>
                    <p class="p_3">成人</p>
                    <el-input-number size="small" v-model="value1" :min="0" :max="999"></el-input-number>
                    <p class="p_3">儿童</p>
                </div>
                <div class="mianLine">
                    <p class="title">您需要的房型和数量</p>
                    <i class="el-icon-circle-plus-outline addIconSy"></i>
                    <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content" style="line-height: 0.2rem;width: 2rem;">
                            亲爱哒，资源方会按照您的总房间数和人数给您提供套餐特价，
                            <span style="color: #DB4E1A;font-weight: bold;">套餐特价不能拆分购买哦。</span>
                            如果是想比较一下哪种房型更便宜，请点击 <span style="font-weight: bold;">比价</span>，
                            填写您想比价的其他房型。
                        </div>
                        <svg-icon class="wenIcon" iconClass="wenhao"></svg-icon>
                    </el-tooltip>
                </div>
                <div class="detail" v-for="item in 1" :key="item">
                    <div class="detailBox">
                        <div class="detailBoxLine">
                            <el-select style="margin-right: 0.1rem;" size="small" v-model="num" placeholder="请选择房型">
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-input style="width: 0.8rem;" size="small" v-model="num" placeholder="数字"></el-input>
                            <p class="detail_p-1">间</p>
                            <el-input style="width: 1.2rem;margin-right: 0.1rem;" size="small" v-model="num"
                                placeholder="期望预算/间"></el-input>
                            <svg-icon style="margin-right: 0.3rem;" class="wenIcon" iconClass="wenhao"></svg-icon>
                            <svg-icon class="closeIcon" iconClass="closeX"></svg-icon>
                        </div>
                        <div class="detailBoxLine">
                            <el-radio-group style="margin-right: 0.3rem;" v-model="radio">
                                <el-radio label="1">含早</el-radio>
                                <el-radio label="2">不含</el-radio>
                                <el-radio label="3">多行</el-radio>
                            </el-radio-group>
                            <el-input size="small" style="width: 2.3rem;margin-right: 0.3rem;" v-model="num"
                                placeholder="其他想问酒店的？"></el-input>
                            <el-button size="small" class="addBtn">比较</el-button>
                        </div>
                        <div class="detailBoxLine">
                            <p class="detail_p-2">您想比较的房型是？</p>
                            <el-select style="margin-right: 0.1rem;" size="small" v-model="num" placeholder="请选择房型">
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div v-if="item !== 2" class="mainDetailLine"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            value1: '',
            num: "",
            radio: '',
            options: [{
                value: '选项1',
                label: '黄金糕'
            }, {
                value: '选项2',
                label: '双皮奶'
            }, {
                value: '选项3',
                label: '蚵仔煎'
            }],
            heatTest: [
                {
                    code: '0',
                    text: '您曾经寻过该资源哦~~'
                },
                {
                    code: '1',
                    text: '寻出来的价格，您也可以出售哦！看看别人出售的特价'
                },
                {
                    code: '2',
                    text: '除了这家酒店还想需要别的产品吗？'
                }
            ]
        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.container {
    .addBtn {
        border-radius: 0.04rem;
        background-color: rgba(230, 74, 25, 0.1);
        color: rgba(16, 16, 16, 1);
        font-size: 0.14rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFang SC;
    }

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.3rem;

        .headerBox {
            padding: 0.1rem;
            border-radius: 0.04rem;
            width: 1.8rem;
            height: 0.8rem;
            background-color: rgba(235, 244, 255, 1);
            text-align: center;
            color: rgba(69, 64, 64, 0.71);
            font-size: 0.14rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: SourceHanSansSC-regular;
        }
    }

    .main {
        .wenIcon {
            // height: 0.2rem;
            color: #000;
            font-weight: bold;
            cursor: pointer;
        }

        .closeIcon {
            height: 0.22rem;
            font-weight: bold;
            cursor: pointer;
        }

        .mainDetail {
            .mainDetailLine {
                margin: 0.2rem 0;
                width: 100%;
                height: 1px;
                border: 2px dashed #5E6B72;
            }

            &:nth-last-child(1) {
                margin-bottom: 0;
            }
        }

        .mianLine {
            margin-bottom: 0.15rem;
            display: flex;
            align-items: center;

            .title {
                color: rgba(16, 16, 16, 1);
                font-size: 0.17rem;
                font-weight: bold;
                font-family: SourceHanSansSC-bold;
            }

            .p_1 {
                color: rgba(16, 16, 16, 1);
                font-size: 0.18rem;
                font-family: SourceHanSansSC-regular;
            }

            .p_2 {
                color: rgba(16, 16, 16, 1);
                font-size: 0.17rem;
                margin-right: 0.15rem;
                font-family: SourceHanSansSC-regular;
            }

            .p_3 {
                margin: 0 0.2rem;
            }



            .addIconSy {
                font-size: 0.3rem;
                color: #DB4E1A;
                font-weight: bold;
                margin-left: 0.2rem;
                margin-right: 0.05rem;
                cursor: pointer;
            }


        }

        .detail {
            margin-bottom: 0.2rem;

            &:nth-last-child(1) {
                margin-bottom: 0;
            }

            .detailBox {
                padding: 0.1rem;
                width: 100%;
                background-color: rgba(255, 255, 255, 1);
                box-shadow: 1px 1px 3px 2px rgba(0, 0, 0, 0.4);

                .detailBoxLine {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.15rem;

                    &:nth-last-child(1) {
                        margin-bottom: 0;
                    }
                }

                .detail_p-1 {
                    font-size: 0.14rem;
                    font-family: SourceHanSansSC-regular;
                    margin: 0 0.1rem;
                }

                .detail_p-2 {
                    color: #101010;
                    font-size: 0.17rem;
                    font-family: SourceHanSansSC-regular;
                    margin-right: 0.1rem;
                }
            }
        }
    }
}
</style>